import { LitElement, html, css } from 'lit';
import { HTTP_CLIENT } from '../../middleware/axiosClient';
import './loading_indicators/spinner-element.js';

class TickerSearchResultsElement extends LitElement {
  static get properties() {
    return {
      activeExchange: String,
      searchText: String,
      searchResults: Array,
      isCardVisible: Boolean,
      showExchangeButtons: { type: Boolean, reflect: true },
      isLoading: Boolean,
    };
  }

  constructor() {
    super();
    this.activeExchange = '';
    this.searchText = '';
    this.searchResults = [];
    this.isCardVisible = false;
    this.showExchangeButtons = true;
    this.isLoading = false;
  }

  async fetchSearchResults() {
    this.isLoading = true;
    try {
      const response = await HTTP_CLIENT.get('/search-ticker', {
        params: {
          query: this.searchText,
          exchange: this.activeExchange
        }
      });
      this.searchResults = response.data;
      this.isCardVisible = true;
    } catch (error) {
      console.error('Error fetching search results:', error);
    } finally {
      this.isLoading = false;
    }
  }

  handleExchangeButtonClick(exchange) {
    this.activeExchange = exchange;
    this.fetchSearchResults();
  }

  handleItemClick(symbol, exchange) {
    this.dispatchEvent(new CustomEvent('ticker-changed', { 
      bubbles: true, 
      composed: true, 
      detail: { symbol, exchange } 
    }));
    this.isCardVisible = false;
  }

  static get styles() {
    return css`
      :host {
        position: relative;
        display: block;
      }
      .ticker-selection-card {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        z-index: 1000;
        background-color: #fff;
        border-radius: 0 0 4px 4px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.12);
      }
      .search-results ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
      }
      .list-item {
        display: flex;
        flex-direction: column;
        color: #2E2E3A;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        line-height: 10px;
        letter-spacing: -0.14px;
        gap: 5px;
        cursor: pointer;
        padding: 10px 16px;
        transition: background 0.15s;
      }
      .list-item:hover {
        background: #f6f7f9;
      }
      .symbol {
        font-size: 14px;
        font-weight: 600;
        margin-top: 5px;
      }
      .name {
        font-size: 12px;
        font-weight: 500;
      }
      .exchange-buttons {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        margin-bottom: 5px;
        padding: 8px 8px 0 8px;
      }
      .exchange-buttons button {
        height: 30px;
        padding: 10px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        color: #2E2E3A;
        font-family: 'Montserrat', sans-serif;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 10px;
        letter-spacing: -0.14px;
        background: #f2f3f7;
        transition: background 0.15s, color 0.15s;
      }
      .exchange-buttons button[active] {
        background-color: #3346e7;
        color: #fff;
      }
      .loading-container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        min-height: 60px;
      }
    `;
  }

  render() {
    if (!this.isCardVisible) return null;

    return html`
      <div class="ticker-selection-card">
        ${this.showExchangeButtons ? html`
          <div class="exchange-buttons">
            <button
              @click=${() => this.handleExchangeButtonClick('')}
              ?active=${this.activeExchange === ''}
            >
              ALL
            </button>
            <button
              @click=${() => this.handleExchangeButtonClick('ETF')}
              ?active=${this.activeExchange === 'ETF'}
            >
              ETF
            </button>
            <button
              @click=${() => this.handleExchangeButtonClick('MUTUAL_FUND')}
              ?active=${this.activeExchange === 'MUTUAL_FUND'}
            >
              MUTUAL FUND
            </button>
            <button
              @click=${() => this.handleExchangeButtonClick('CRYPTO')}
              ?active=${this.activeExchange === 'CRYPTO'}
            >
              CRYPTO
            </button>
            <button
              @click=${() => this.handleExchangeButtonClick('NASDAQ')}
              ?active=${this.activeExchange === 'NASDAQ'}
            >
              NASDAQ
            </button>
            <button
              @click=${() => this.handleExchangeButtonClick('NYSE')}
              ?active=${this.activeExchange === 'NYSE'}
            >
              NYSE
            </button>
          </div>
        ` : ''}
        <div class="search-results">
          ${this.isLoading ? html`
            <div class="loading-container">
              <spinner-element></spinner-element>
            </div>
          ` : html`
            <ul>
              ${this.searchResults.map((result) => html`
                <li class="list-item" @click="${() => this.handleItemClick(result.symbol, result.exchange)}">
                  <span class="symbol">${result.symbol}</span>
                  <span class="name">${result.name}</span>
                </li>
              `)}
            </ul>
          `}
        </div>
      </div>
    `;
  }
}

customElements.define('ticker-search-results-element', TickerSearchResultsElement); 